import { formatCount } from '../../../lib/format';

/**
 * A ranked count as a list of bars: the name, a bar as long as its share of the largest, and the number. Used where
 * the names are words customers chose (topics, outcomes, why chats stopped, flow steps), which a chart's axis would
 * squeeze into three lines. One colour for every bar, because the bars are one measure; the number is printed beside
 * each, so the length is never the only way to read it.
 */
export function BarList({ items, label, testId }: { items: { name: string; value: number }[]; label: string; testId?: string }) {
  const max = Math.max(1, ...items.map((i) => i.value));
  return (
    <ul className="rr-insights__barlist" aria-label={label} data-testid={testId}>
      {items.map((i) => (
        <li key={i.name} title={`${i.name}: ${formatCount(i.value)}`}>
          <span className="rr-insights__barlist-name">{i.name}</span>
          <span className="rr-insights__barlist-track" aria-hidden>
            <span className="rr-insights__barlist-bar" style={{ width: `${Math.max(2, (i.value / max) * 100)}%` }} />
          </span>
          <span className="rr-insights__barlist-value">{formatCount(i.value)}</span>
        </li>
      ))}
    </ul>
  );
}
